import React from 'react';
import { Link, useRouteMatch } from 'react-router-dom';
import {
    AnimatedPageLoader,
    ErrorAlert,
    Ticket,
    TicketHeader,
    TicketBody,
    VerticalFlex,
    AccentLabel,
    HorizontalFlex,
    InfoAlert,
} from 'smartsuite-ui';
import { useQuery } from 'react-query';
import { DateTimeFormatter } from 'brock-date-time/lib/DateTimeFormatter';
import useSortable from '../../hooks/useSortable';
import { buildFlightListQuery } from '../../utils/apiUtils';

export default function FlightList(props) {
    const { path } = useRouteMatch();

    const { isLoading, isError, data, error } = useQuery(
        buildFlightListQuery(props.airlineCode, props.selectedStation, props.outboundTerminal)
    );

    const [sortObject, setSort, sortedResults] = useSortable(data, {
        columnName: 'departureTime',
        sortOrder: 'asc',
    });

    if (isLoading) {
        return <AnimatedPageLoader />;
    }

    if (isError) {
        return <ErrorAlert>Something went wrong</ErrorAlert>;
    }

    if (sortedResults == null || sortedResults.length === 0) {
        return <InfoAlert>No flights available for your criteria</InfoAlert>;
    }

    return (
        <div className='flight-list'>
            {sortedResults.map((flight) => (
                <Ticket>
                    <TicketHeader>
                        <VerticalFlex>
                            <AccentLabel>Flight</AccentLabel>
                            <Link to={`${path}/${flight.id}`}>
                                {flight.flightIdentifier}
                            </Link>
                        </VerticalFlex>
                    </TicketHeader>
                    <TicketBody>
                        <HorizontalFlex
                            cssClassModifiers={[
                                'align-flex-start',
                                'space-between',
                            ]}
                        >
                            <VerticalFlex>
                                <AccentLabel>Destination</AccentLabel>
                                <span>{flight.destination}</span>
                            </VerticalFlex>
                            <VerticalFlex>
                                <AccentLabel>Estimated/Actual Dep.</AccentLabel>
                                <span>
                                    {DateTimeFormatter.timeLocal(
                                        flight.departureTime
                                    )}
                                </span>
                            </VerticalFlex>
                            <VerticalFlex>
                                <AccentLabel>En Route</AccentLabel>
                                <span>{flight.bagsEnroute}</span>
                            </VerticalFlex>
                        </HorizontalFlex>
                    </TicketBody>
                </Ticket>
            ))}
        </div>
    );
}
